import type { ComponentDocMap } from './types'

/**
 * Prop documentation for the `table` component.
 * Keep in sync with TableProps in src/ui/uiConfig/components/Table/Table.types.ts
 */
export const tablePropDocs: ComponentDocMap = {
  columns: {
    description: 'Table column definitions.',
    type: 'TableColumn[]',
    example: '[{ Header: "__Unit", accessor: "title", is_dataset: false }]',
  },
  'columns[].Header': {
    description: 'Column header title.',
    type: 'string | number | undefined',
  },
  'columns[].accessor': {
    description: 'Row key used for this column.',
    type: 'string',
  },
  'columns[].is_dataset': {
    description: 'Marks dataset-backed columns for value formatting.',
    type: 'boolean',
  },
  rows: {
    description: 'Row data rendered in the table.',
    type: 'TableRow[]',
    example: '[{ title: "__Boiler A", value: 12.4, unit: "MW", decimals: 1 }]',
  },
  'rows[].unit': {
    description: 'Optional row-level unit.',
    type: 'string',
  },
  'rows[].data_type': {
    description: 'Optional row-level data type for formatting.',
    type: 'string',
  },
  'rows[].decimals': {
    description: 'Optional row-level decimal precision.',
    type: 'number',
  },
  title: {
    description: 'Optional table title.',
    type: 'string',
    example: '"__Production table"',
  },
  no_padding: {
    description: 'Removes default table card/container padding.',
    type: 'boolean',
  },
  no_header: {
    description: 'Hides table header row.',
    type: 'boolean',
  },
}
